import { render } from "./FlyConfigSwitch.vue?vue&type=template&id=f1f5032e"
import script from "./FlyConfigSwitch.vue?vue&type=script&lang=js"
export * from "./FlyConfigSwitch.vue?vue&type=script&lang=js"

import "./FlyConfigSwitch.vue?vue&type=style&index=0&id=f1f5032e&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__